import { Box, Typography } from '@mui/material';
import { IconCircleCheck, IconCircleX, IconX } from '@tabler/icons-react';
import { toast } from 'react-toastify';

export const showErrorToast = (messageTitle, messageDescription, toastWidth, textWidth, backgroundColor, error = false) => {
  const toastContent = ({ closeToast }) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        width: toastWidth,
        height: error ? '74px' : '52px',
        padding: '16px',
        boxSizing: 'border-box',
        background: backgroundColor,
        borderRadius: '16px'
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: error ? '6px' : 0,
          }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px'
            }}>
            {error ? <IconCircleX color="#FFFFFF" size={20} /> : <IconCircleCheck color="#FFFFFF" size={20} />}
            <Typography
              style={{
                color: '#FFFFFF',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '21px',
                fontFamily: 'Noto Sans',
                width: textWidth,
                height: '20px'
              }}>
              {messageTitle}
            </Typography>
          </Box>
          <Box
            sx={{
              width: '20px',
              height: '20px',
              minWidth: '20px',
              minHeight: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              cursor: 'pointer'
            }}
            onClick={closeToast}>
            <IconX color="#ffffff" size={20} strokeWidth={2} />
          </Box>
        </Box>
        <Typography
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '21px',
            fontFamily: 'Noto Sans',
            width: textWidth,
            height: '20px',
            marginLeft: '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}>
          {messageDescription}
        </Typography>
      </Box>
    </Box>
  );
  const toastId = error ? 'save-unsave-error-id' : 'save-unsave-success-id';
  const toastOption = {
    toastId,
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeButton: false,
    icon: false,
    style: {
      padding: 0,
      margin: 0,
      background: 'transparent',
      boxShadow: 'none',
      minHeight: 'unset',
      borderRadius: '8px'
    }
  };
  
  if (toast.isActive(toastId)) {
    toast.update(toastId, {
      ...toastOption,
      render: toastContent,
      autoClose: 5000
    });
  } else {
    toast(toastContent, toastOption);
  }
};
